import { HashLink as Link } from 'react-router-hash-link';
import './Navbar.css';
import { useState } from 'react';

export default function Navbar() {
  const [clickState, setClickState] = useState(false);

  const toggleMenu = () => {
    setClickState(!clickState);
  };

  return (
    <nav className="navbar">
      <div className={`navbar-button ${clickState ? "change" : ""}`} onClick={toggleMenu}>
        <span className="span1" />
        <span className="span2" />
        <span className="span3" />
      </div>

      <div className="navbar-links-desktop">
        <Link className="nav-link" smooth to="/#top" scroll={el => {
    const yOffset = -170; // säätö headerin korkeuden mukaan
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }}>Etusivu</Link>
        <Link className="nav-link" smooth to="/#info" scroll={el => {
    const yOffset = -130; // säätö headerin korkeuden mukaan
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }}>Info</Link>
        <Link className="nav-link" smooth to="/#members" scroll={el => {
    const yOffset = -130; // säätö headerin korkeuden mukaan
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }}>Jäsenet</Link>
        <Link className="nav-link" smooth to="/#listen" scroll={el => {
    const yOffset = -170; // säätö headerin korkeuden mukaan
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }}>Kuuntele</Link>
        <Link className="nav-link" to="/references#top">Referenssit</Link>
        <Link className="nav-link" smooth to="/#contact" scroll={el => {
    const yOffset = -150; // säätö headerin korkeuden mukaan
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }}>Yhteys</Link>
      </div>

      {clickState && (
        <div className="navbar-links-mobile">
          <Link className="nav-link" smooth to="/#top" onClick={() => setClickState(false)} >Etusivu</Link>
          <Link className="nav-link" smooth to="/#info" onClick={() => setClickState(false)} >Info</Link>
          <Link className="nav-link" smooth to="/#members" onClick={() => setClickState(false)} >Jäsenet</Link>
          <Link className="nav-link" smooth to="/#listen" onClick={() => setClickState(false)} >Kuuntele</Link>
          <Link className="nav-link" to="/references#top" onClick={() => setClickState(false)}>Referenssit</Link>
          <Link className="nav-link" smooth to="/#contact" onClick={() => setClickState(false)} >Yhteys</Link>
        </div>
      )}
    </nav>
  );
}
